import { combineReducers } from 'redux';
import blog from './blog';
import post from './post';
import env from './env';
import gnb from './gnb';
import FooterReducer from './footer';
import editor from './editor';
import plugins from './plugins';

export default combineReducers({
  footer: FooterReducer,
  gnb,
  env,
  blog,
  post,
  editor,
  plugins,
});
